import { render, staticRenderFns } from "./PurchaseDone.vue?vue&type=template&id=04fcc096&"
import script from "./PurchaseDone.vue?vue&type=script&lang=js&"
export * from "./PurchaseDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports